import icon from "../../Icons/icon_brightness_38.png";
import Accardion from "../extras/Landing/Accardion";
import {useSelector} from "react-redux";
import {faqSelector} from "../../Slices/ticketslice";
import {LinearProgress} from "@mui/material";

const Bottombox = () => {

    const status = useSelector((state)=>state.ticket.status)
    const dataneeded = [
            {
                id: 1,
                q: 'پس از دریافت بلیط جهت ورود به سالن ارائه چه مدارکی لازم است ؟',
                answer: 'برای ورود به سالن در دست داشتن فایل چاپ شده بلیط یا تصویر دانلود شده آن کافیست. ',
                safir: 0
            },
            {
                id: 2,
                q: 'نحوه دریافت بلیط به چه شکل است ؟',
                answer: 'پس از پرداخت هزینه و اتمام سفارش شما به می توانید فایل pdf بلیط خود را مشاهده، دانلود و یا چاپ کنید. ',
                safir: 0
            },
            {
                id: 3,
                q: 'پس از رزرو بلیت تا چه زمانی می توانیم خرید خود را نهایی کنیم؟',
                answer: 'شما پس از رزرو جایگاه خود تا پانزده دقیقه فرصت دارید تا خرید خود را نهایی کنید؛ پس از این مدت صندلی انتخاب شده آزاد می شود و فرد دیگری می تواند نسبت به رزرو آن اقدام کند. ',
                safir: 0
            }
        ]




    let content
    if (dataneeded) {

        content = dataneeded.map((d)=>(
            <Accardion key={d.id} a={d.answer} q={d.q} id={d.id}/>
        ))


    } else {
        content = <div className='column is-12'>
            <LinearProgress variant='indeterminate' color='info'/>
        </div>
    }




    return (
        <>
            <section>
                <div className='columns mx-0 is-multiline navpadend150 navpadstart150  mb-6'>



                            <div className='column is-12 '>

                                <img src={icon} alt="icon" style={{transform: 'translateY(1rem) translateX(1.6rem)'}}/>
                                <h3 className='is-size-4-mobile is-size-4 has-text-weight-bold pinar mb-3'>
                                    سوالات متداول

                                </h3>
                            </div>

                            {content}










                </div>


            </section>


        </>

    )
}
export default Bottombox